'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = function () {
    (0, _templates.addTemplates)({
        includedLink: function includedLink(e, urlPropName) {
            var url = e.data[urlPropName];
            if (url) {
                return '<a href="' + url + '">' + e.value + '</a>';
            }
            return e.value;
        },
        authors: function authors(e) {
            return e.value ? e.value.map(function (v) {
                return '<a href="' + (0, _config2.default)().url.authorProducts(v) + '" title="' + v.type + '">' + v.name + '</a>';
            }).join(', ') : null;
        },
        authorsWithoutLink: function authorsWithoutLink(e) {
            return e.value ? e.value.map(function (v) {
                return '<span>' + v.name + '</a>';
            }).join(', ') : null;
        },
        amountLimit: function amountLimit(e) {
            return e.value > this.amountAvailableLimit ? this.amountAvailableLimit + '+' : e.value;
        },
        invoiceState: function invoiceState(e) {
            if (e.value === 'Unpaid') {
                return '<div class="unpaid-invoice" data-toggle="tooltip" data-original-title="' + Resx.App.InvoiceStatus_Unpaid + '"/>';
            }
            if (e.value === 'Paid') {
                return '<div class="paid-invoice" data-toggle="tooltip" data-original-title="' + Resx.App.InvoiceStatus_Paid + '"/>';
            }
            return '<div class="new-invoice" data-toggle="tooltip" data-original-title="' + Resx.App.InvoiceStatus_New + '"/>';
        },
        packages: function packages(e) {
            if ((0, _isArray2.default)(e.value)) {
                return e.value.map(function (x) {
                    return createPackageLink(x);
                }).join(', ');
            }

            var dto = (0, _assign2.default)({}, (0, _typeof3.default)(e.value) === 'object' ? e.value : {
                trackingNumber: e.value,
                urlTemplate: e.value,
                name: e.value
            });
            return createPackageLink(dto);

            //return e.value
            //    ? e.value.map(v => `<a href="#${v}" target="blank">${v}</a>`).join(', ')
            //    : null;
        },
        addToCart: function addToCart(e, productIdProp, preorderProp, customerIdProp) {
            var args = {
                productId: (0, _get3.default)(this, productIdProp || 'productId'),
                tabIndex: e.meta.row + 5000,
                customerId: (0, _get3.default)(this, customerIdProp || 'customerId'),
                amount: e.value,
                preorder: (0, _get3.default)(this, preorderProp || 'preorder')
            };
            if (args.customerId == _abp2.default.session.customerId) {
                delete args.customerId;
            }
            //if (this.canPurchase) {
            return '<div class="products-view-table"><div class="add-shop"\n                    data-component="AddToCart"\n                    data-component-args=\'' + (0, _stringify2.default)(args) + '\'>\n                </div></div>';
            //} else {
            //	return `<span>${this.amount || 0}</span>`;
            //}
        },
        chooseCustomer: function chooseCustomer(e) {
            var returnUrl = _querystring2.default.parse(window.location.href).returnUrl;
            if (!returnUrl) returnUrl = "";
            var link = '<a href=\'' + linksoft.url.setCustomer({ id: this.id, returnUrl: returnUrl }) + '\'>' + e.value + '</a>';
            return link;
        },
        orderState: function orderState(e) {
            var item = e.column.enumValue(e.value) || { id: -1, text: "undefined" };
            return item.text;
        },
        orderItemState: function orderItemState(e) {
            var item = e.column.enumValue(e.value) || { id: -1, text: "undefined" };
            return item.text;
        },
        language: function language(e) {
            return e.reference;
        },
        downloadDeliveryNote: function downloadDeliveryNote(e) {
            return '\n        <a href="' + linksoft.url.userDownloadDeliveryNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n        &nbsp;|&nbsp;\n        <a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        downloadUnconfirmedDeliveryNote: function downloadUnconfirmedDeliveryNote(e) {
            return '\n            <div class="checkbox">\n                <input type="checkbox" name="SelectedDeliveryNotes" value="' + e.value + '" id="unconfirmed-delivery-notes-checkbox-' + e.value + '" checked unconfirmed-delivery-notes-checkbox/>\n            <label for="unconfirmed-delivery-notes-checkbox-' + e.value + '"></label>\n            </div>\n            &nbsp;|&nbsp;\n            <a href="' + linksoft.url.userDownloadDeliveryNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n            &nbsp;|&nbsp;\n            <a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        downloadUnconfirmableDeliveryNote: function downloadUnconfirmableDeliveryNote(e) {
            return '\n            <a href="' + linksoft.url.userDownloadDeliveryNote(this) + '" title="' + Resx.App.CustomDownload + '"><i class="fa fa-download"></i></a>\n            &nbsp;|&nbsp;\n            <a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        downloadExcel: function downloadExcel(e, urlName) {
            return '<a href="' + linksoft.url[urlName](this) + '" title="' + Resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },
        download: function download(e, urlName, title) {
            var hasFileName = this.hasFileName;
            if (hasFileName) {
                return '<a invoice-id=' + this.id + ' href="' + linksoft.url[urlName](this) + '" title="' + title + '"><i class="fa fa-download"></i></a>';
            } else {
                return "";
            }
        },
        sendNewsletterCheckbox: function sendNewsletterCheckbox(e) {
            return '<input type="checkbox" ' + (e.value ? "checked=\"checked\"" : "") + ' id="dt-sendnewsletter-' + this.id + '" data-user-sendnewsletter="true" data-userid="' + this.id + '"/>\n                <label for="dt-sendnewsletter-' + this.id + '"></label>';
        },
        minMaxAmountSetting: function minMaxAmountSetting(e) {
            return '<div data-min-max-setting="' + this.productId + '" class="stock-value-wrap nowrap">\n                        <button class="edit-stock-amount btn-green" type="button"><i class="fa fa-save"></i></button>\n                        <input name="minAmount" type="number" value="' + this.minAmount + '" data-value="' + this.minAmount + '" placeholder="min">\n                        &nbsp;-&nbsp;\n                        <input name="maxAmount" type="number" value="' + this.maxAmount + '" data-value="' + this.maxAmount + '" placeholder="max">\n                    </div>';
        },
        salesStats: function salesStats(e) {
            // TODO: localize
            return '<span title="za 30 dn\xED">' + e.value.amount1 + '</span>\n                &nbsp;|&nbsp;\n                <span title="za 60 dn\xED">' + e.value.amount2 + '</span>\n                &nbsp;|&nbsp;\n                <span title="za 90 dn\xED">' + e.value.amount3 + '</span>';
        },
        deliveryMethod: function deliveryMethod(e) {
            return e.value ? '<span class="product-icon product-icon-k product-icon--small" data-toggle="tooltip" data-original-title="Do komise"></span>' : '<span class="product-icon product-icon-f product-icon--small" data-toggle="tooltip" data-original-title="Pouze na fakturu"></span>';
        },
        invoiceLink: function invoiceLink(e, urlName) {
            if ((0, _isArray2.default)(e.value)) {
                return e.value.map(function (x) {
                    return createInvoiceLink(urlName, x);
                }).join(e.formatString || '');
            }

            var args = {};
            if (typeof key === 'string') {
                args.id = this[key];
            }

            var dto = (0, _assign2.default)({}, (0, _typeof3.default)(e.value) === 'object' ? e.value : {
                id: e.value,
                name: e.value,
                hasFileName: e.value
            }, args);
            return createInvoiceLink(urlName, dto);
        },
        singleInvoiceLink: function singleInvoiceLink(e, urlName) {

            var dto = (0, _assign2.default)({}, { id: this.id, name: e.value, hasFileName: this.hasFileName });
            return createInvoiceLink(urlName, dto);
        },
        eanLink: function eanLink(e) {
            return e.value ? '<a href="' + (0, _config2.default)().url.product({ id: e.data.productId, name: e.data.productName }) + '">' + e.value + '</a>' : '<span>' + e.value + '</span>';
        },
        addressEditLink: function addressEditLink(e) {
            var params = { id: this.id };
            return '<a class="edit" title="' + Resx.Common.Edit + '" href="' + linksoft.url.addressEdit(params) + '"><i class="fa fa-edit"></i></a>';
        },
        amountAvailable: function amountAvailable(e) {
            var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

            if (typeof e.value === 'number') {
                if (e.value <= 0) return '<span class="amount-zero">0</span>';else if (e.value >= limit && !_abp2.default.auth.isGranted('ProductService.CanSeePreciseAmountAvailable')) {
                    return limit + '+';
                }
            }
            return e.value;
        },
        cancelOrderItem: function cancelOrderItem(e) {
            if (this.state === "Processing" && this.cancelRequest == null && this.canCancel === true) {
                var cancelAmount = this.amountToCancel;
                return '<a href="#" class="red" data-cancel-order-item="' + this.id + '" data-cancel-order-item-name="' + this.productName + '" data-cancel-order-item-amount="' + cancelAmount + '" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.Common.Cancel + '"><i class="fa fa-remove"></i></a>';
            } else if (this.state != "Canceled" && !(this.cancelRequest == null) && this.cancelAccepted == null) {
                return '<i class="fa fa-cogs" data-toggle="tooltip" data-placement="top" data-original-title="' + Resx.App.ProcessingAmount + '"></i>';
            } else if (this.state === "Canceled" || this.cancelAccepted === true) {
                if (this.cancelResultMessage) {
                    return '<i class="fa fa-check green"></i>&nbsp;&nbsp;<i class="fa fa-info" onclick="abp.message.info(\'' + this.cancelResultMessage + '\', \' \');"></i>';
                } else {
                    return '<i class="fa fa-check green"></i>';
                }
            } else if (this.cancelAccepted === false) {
                if (this.cancelResultMessage) {
                    return '<i class="fa fa-ban red" data-toggle="tooltip" data-placement="bottom" data-original-title="Zam\xEDtnuto"></i>&nbsp;&nbsp;<i class="fa fa-info" onclick="abp.message.info(\'' + this.cancelResultMessage + '\', \' \');"></i>';
                } else {
                    return '<i class="fa fa-ban red" data-toggle="tooltip" data-placement="bottom" data-original-title="Zam\xEDtnuto"></i>';
                }
            }
        },
        productListIcon: function productListIcon(e) {
            var retval = "";

            if (this.isBestseller) {
                retval += '<span class="product-icon product-icon-b product-icon--small" data-toggle="tooltip" data-original-title="' + L("Common:Bestseller") + '"></span>';
            }

            if (this.isSpecialOffer) {
                retval += '<span class="product-icon product-icon-a product-icon--small" data-toggle="tooltip" data-original-title="' + L("App:SpecialOffer") + '"></span>';
            }

            if (this.isNew) {
                retval += '<span class="product-icon product-icon-n product-icon--small" data-toggle="tooltip" data-original-title="' + L("App:New") + '"></span>';
            } else if (this.isUpcoming) {
                retval += '<span class="product-icon product-icon-u product-icon--small" data-toggle="tooltip" data-original-title="' + L("App:Upcoming") + '"></span>';
            }

            if (this.isFutureReprint) {
                retval += '<span class="product-icon product-icon-fd product-icon--small" data-toggle="tooltip" data-original-title="' + L("Common:Reissue") + '"></span>';
            } else if (this.isReprint) {
                retval += '<span class="product-icon product-icon-d product-icon--small" data-toggle="tooltip" data-original-title="' + L("Common:Reissue") + '"></span>';
            }

            if (this.isDiscounted !== null) {
                retval += '<span class="product-icon product-icon-s product-icon--small" data-toggle="tooltip" data-original-title="' + L("App:Sale") + '"></span>';
            }

            return retval === "" ? "<span />" : retval;
        },
        productListThumbnail: function productListThumbnail(e) {
            return '<a href="/Product/Detail/' + this.id + '">' + ('<img class="img-responsive" alt="' + this.name + '" data-src="' + this.thumbnailUrl + '" src="">') + '</a>';
        },
        productListNames: function productListNames(e) {
            var authorsString = [];
            for (var i = 0; i < this.literaryAuthors.length; i++) {
                authorsString.push("<a href='/Author/Detail/" + this.literaryAuthors[i].id + "'>" + this.literaryAuthors[i].name + "</a>");
            }

            return '<span><a href="/Product/Detail/' + this.id + '">' + this.name + '</a></span>, <span>' + authorsString.join(", ") + '</span><br /><span>' + (this.subheading !== null ? this.subheading : "") + '</span>';
        },
        productListPrices: function productListPrices(e) {
            // TODO: Localize
            return '<span>B\u011B\u017En\xE1 cena: ' + this.normalPrice + '</span><br /><span>Trvale sn\xED\u017Een\xE1 cena: ' + this.oldPrice + '</span><br /><span>' + L("App:YourPrice") + ': ???</span>';
        },
        productListMisc: function productListMisc(e) {
            return '<span>' + L("App:PublishingHouse") + ': <a href="/Product/PublishingHouse/' + this.publishingHouse.id + '">' + this.publishingHouse.name + '</a></span><br /><span>' + L("App:IssueDate") + ': ' + new Date(this.releaseDate).toLocaleDateString() + '</span><br /><span>' + L("App:AmountAvailable") + ': ' + (this.isInStock ? L("App:AmountInStock") : L("App:ProductUnsaleable")) + '<span><br /><span>' + L("App:Reduction") + ': ???%</span>';
        },
        deleteButton: function deleteButton() {
            return '<a data-control-button-delete="' + this.id + '" data-confirm="' + Resx.Messages.ConfirmDelete + '" data-confirm-title="' + Resx.Messages.ConfirmTitle + '" class="remove" href="#">\n                      <i class="fa fa-remove"></i>\n                      </a>';
        },
        editButton: function editButton(e, editUrl) {
            var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return editUrl ? '<a class="edit" title="' + Resx.Common.Edit + '" ' + attributes + ' href="' + linksoft.url[editUrl](this) + '"><i class="fa fa-edit"></i></a>' : "";
        },
        editModalButton: function editModalButton(e, editUrl) {
            var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return editUrl ? '<a class="edit" title="' + Resx.Common.Edit + '" data-modal-link data-url="' + linksoft.url[editUrl](this) + '" ' + attributes + ' ><i class="fa fa-edit"></i></a>' : "";
        },
        truncate: function truncate(e, length) {
            return e.value.length > length ? e.value.substring(0, length) + "..." : e.value;
        },
        price: function price(e, priceType) {
            return (0, _linksoftAlbatros.formatPrice)(e.value, priceType);
        }
    });

    function createInvoiceLink(urlName, args) {
        var fn = (0, _config2.default)().url[urlName];
        var url = "javascript:void(0)";
        if (typeof fn === 'function') {
            url = fn(args);
        } else {
            _abp2.default.log.error('Function window.linksoft.url.' + urlName + ' is missing.');
        }
        if (args.hasFileName) {
            return '<a invoice-id=' + args.id + ' href="' + url + '">' + args.name + '</a> ';
        } else {
            return '<span>' + args.name + '</span> ';
        }
    }

    function createPackageLink(pack) {
        var url = pack.urlTemplate;
        var trackingNumber = pack.trackingNumber;
        var name = pack.name;
        var link = "";

        if (url) {
            var first = url.substring(0, url.indexOf('{'));
            var second = url.substring(url.indexOf('}') + 1);
            if (second) {
                link = first + trackingNumber + second;
            } else {
                link = first + trackingNumber;
            }
            if (trackingNumber && name) {
                return '<span></span><a target="_blank" href="' + link + '">' + name + '</a>';
            } else if (name) {
                return '<span>' + name + '</span>';
            } else {
                return '<span> - </span>';
            }
        } else if (name) {
            return '<span>' + name + '</span>';
        } else {
            return '<span> - </span>';
        }
    }
};

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _templates = require('linksoft/data-tables/templates');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _querystring = require('linksoft/utils/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("App", "Messages", "Common");

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/table-templates.js
// module id = 1093
// module chunks = 1